import Eyebrow from "./shared/Eyebrow";
import TypedHeading from "./shared/TypedHeading";
import Reveal from "./shared/Reveal";
import useProcessProgress from "../hooks/useProcessProgress";
import useI18n from "../i18n/useI18n";

const ProcessTimeline = () => {
  const { t } = useI18n();
  const { sectionRef, progress } = useProcessProgress();
  const steps = t("process.steps");

  return (
    <section id="process" className="process section" ref={sectionRef}>
      <div className="process__inner">
        <Reveal><Eyebrow>{t("process.eyebrow")}</Eyebrow></Reveal>
        <TypedHeading text={t("process.title")} className="process__title" />

        <div className="process__timeline">
          <div className="process__rail" aria-hidden="true">
            <div className="process__rail-fill" style={{ height: `${progress * 100}%` }} />
          </div>

          <div className="process__steps">
            {Array.isArray(steps) &&
              steps.map((step, i) => (
                <Reveal as="article" className="process__step" key={i}>
                  <span className="process__dot" aria-hidden="true" />
                  <div className="process__step-head">
                    <span className="process__bignum">{String(i + 1).padStart(2, "0")}</span>
                    <h3 dir="ltr" className="process__step-name">{step.name}</h3>
                  </div>
                  <p className="process__step-desc">{step.desc}</p>
                </Reveal>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;
